import { useQuery } from "@tanstack/react-query";
import { Divider, Form, Input, Modal, ModalProps, Typography } from "antd";
import { useForm } from "react-hook-form";
import { FormItem } from "react-hook-form-antd";
import { journalsQueries, useJournalMutation } from "@entities/journal";
import { CloseIconLarge } from "@shared/assets/svg/icons";

import "./cancel-sign-modal.scss";

interface CancelSignModalProps extends Omit<ModalProps, "children" | "onOk"> {
  titleId: string;
  representativeId: string;
  constructionControlId: string;
}

export function CancelSignModal({
  titleId,
  representativeId,
  constructionControlId,
  onCancel,
  ...rest
}: CancelSignModalProps) {
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<{ comment: string }>({
    mode: "onSubmit",
    resolver: async (values) => ({
      values: values.comment ? values : {},
      errors: !values.comment
        ? {
            comment: {
              type: "required",
            },
          }
        : {},
    }),
  });

  const { refetch } = useQuery(journalsQueries.getTitleJournal({ titleId }));

  const { mutateAsync: mutate, isPending } = useJournalMutation(
    "post",
    "/api/v1/journals/title/{titleId}/sign/reject",
  );

  const handleOk = async (data: { comment: string }) => {
    await mutate(
      {
        body: {
          signer: {
            representativeId,
            constructionControlId,
          },
          comment: data.comment,
        },
        params: {
          path: {
            titleId,
          },
        },
      },
      {
        onSuccess: () => {
          if (onCancel) {
            // @ts-expect-error не нужный event
            onCancel();
            refetch();
          }
        },
      },
    );
  };

  return (
    <Modal
      title="Отклонить подписание"
      onCancel={onCancel}
      onOk={handleSubmit(handleOk)}
      closeIcon={<CloseIconLarge />}
      width={480}
      centered
      destroyOnClose
      okText="Отказаться"
      okButtonProps={{
        disabled: !isValid,
      }}
      confirmLoading={isPending}
      {...rest}
    >
      <Typography
        style={{
          fontSize: "14px",
          lineHeight: "20px",
          marginTop: "24px",
          marginBottom: "16px",
          color: "#333333",
        }}
      >
        Вы действительно хотите отклонить подписание?
      </Typography>

      <Form layout="vertical">
        <FormItem
          control={control}
          name="comment"
          style={{ color: "#333333", marginBottom: "16px" }}
          label="Причина"
        >
          <Input.TextArea autoSize style={{ minHeight: "56px" }} />
        </FormItem>
      </Form>
      <Divider style={{ margin: "16px 0" }} />
    </Modal>
  );
}
